<label [class.weight-medium]="bold" [ngStyle]="{ 'font-size': size }">
  <input
    *ngIf="checkboxVisible"
    (change)="checked.emit(isChecked)"
    type="checkbox"
    [(ngModel)]="isChecked"
    name="check"
    [id]="id"
  />
  <span
    *ngIf="labelVisible"
    [class.label-left]="side === 'left'"
    [class.label-right]="side === 'right'"
    [ngStyle]="{ 'text-transform': textForm }"
    >{{ label }}</span
  >
</label>
<label></label>
